import Vue from 'vue';

export const signatureSetup = Vue.observable({ context: null });

export const queueSignatureSetup = (context) => {
  signatureSetup.context = { ...context };
};

export const clearSignatureSetup = () => { signatureSetup.context = null; };
